import { render, staticRenderFns } from "./videoLib.vue?vue&type=template&id=4908c65a&scoped=true"
import script from "./videoLib.vue?vue&type=script&lang=js"
export * from "./videoLib.vue?vue&type=script&lang=js"
import style0 from "./videoLib.vue?vue&type=style&index=0&id=4908c65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4908c65a",
  null
  
)

export default component.exports